import Navigation from "./lib/navigation";
import stickyContent from "./lib/stickyContent";
import Accordion from "./lib/accordion";
import SmoothScroll from "smooth-scroll";
import Splide from "@splidejs/splide";

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if (toggle.href == "#") {
      return 0;
    } else {
      const headerHeight = document.querySelector(".header")
        ? document.querySelector(".header").offsetHeight
        : 0;
      return headerHeight;
    }
  },
});

Navigation("header-nav__btn", "body");

const is_font_page = document.querySelector("body.home");
const stickyThreshold = document.querySelector(".js-header").clientHeight;
stickyContent("footer", "header", stickyThreshold);

const faq = new Accordion(".js-faq", {
  speed: 400,
  target: "next",
  event: "click",
  display: "flex",
});
